import React from 'react';

import {IconComponent} from "../../reusable/simpleComponents";
import {triggerDatepicker} from "../../../store/layouts/actions";
import {useDispatch, useSelector} from "react-redux";
import {ApplicationState} from "../../../store";
import {LayoutState} from "../../../store/layouts/types";

const DatePickerUIComponent = () => {
    const dispatch = useDispatch();
    const { datePickerIsOpened } = useSelector<ApplicationState, LayoutState>(state => state.layouts);

    const handler = () => {
        dispatch(triggerDatepicker(!datePickerIsOpened))
    };

    return(
        <div className='setData-wrapper flex js-c'>
            <IconComponent classValue='clock icon'
                           handler={handler}
                           title="Go to Date/Time"
            />
        </div>
    )
};

export default DatePickerUIComponent